import { POST } from "../API"
let source;
export const canStartConversationApi = (phoneNumber, onSuccess, onError) => {
    const data = {
        phone_number: phoneNumber
    }
    source = POST(`/api/v1/chat/contacts/can_start_conversation`, data, onSuccess, onError, true, source)
}